module.exports = __webpack_public_path__ + "media/lobby_normal2.8c15fa66.mp3";